import { render, staticRenderFns } from "./Exhibit.vue?vue&type=template&id=0e88852c&scoped=true&"
import script from "./Exhibit.vue?vue&type=script&lang=js&"
export * from "./Exhibit.vue?vue&type=script&lang=js&"
import style0 from "./Exhibit.vue?vue&type=style&index=0&id=0e88852c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e88852c",
  null
  
)

export default component.exports